<template>

    <div class="arm-not-found arm-border-deco overlay-gradient">
   
        <div class="banner__container">
                                    
            <div class="container">

                <div class="arm-text-inner">

                    <p class="banner__surtitle surtitle">Page introuvable</p>
                                                                                    
                    <h1 class="banner__title">OUPS</h1>
                            
                    <p class="banner__desc">Il semble que la page que vous recherchez n'existe pas.</p>
                            
                    <div class="banner__cta-container flex-display flex-wrap">
                       
                        <a class="btn btn-secondary" href="https://www.armorlux.com" target="_self">
                            Revenir à la page d'accueil
                        </a>

                    </div>

                </div>

            </div>
            
        </div>

    </div>

</template>

<style scoped>


    .arm-not-found .banner__container > .container  {
        display: flex;
        justify-content: flex-end;
    }

    .arm-not-found{
        height: 400px;
        background-image: url('/625ea8c2c9dc7_01003_ARMORLUX_CC_0394_1_adobe98.webp');
        position: relative;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
    }

    .arm-text-inner {
        color:#ffffff;
        max-width: 750px;
        padding-top:50px;
        z-index:2
    }

    .arm-text-inner .surtitle {
        font-size: 1.714em;
        font-weight: 700;
        font-family: "CabinetGrotesk-Bold", sans-serif;
        margin-bottom: 0px;
    }

    .arm-text-inner .banner__desc {
        font-size: 18px;
        font-weight: 500;
        font-family: "CabinetGrotesk-Regular", sans-serif;
    }

    .arm-text-inner h1 {
        font-size: 6.929em;
        font-weight: 700;
        font-family: "CabinetGrotesk-Bold", sans-serif;
    }

    .arm-border-deco::before {
        content: "";
        position: absolute;
        z-index: 1;
        top: 20px;
        right: 20px;
        bottom: 20px;
        left: 20px;
        border: 1px solid #fff;
    }

    .arm-not-found.overlay-gradient::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: linear-gradient(0deg, rgba(11, 31, 44, 0.7) 9%, rgba(11, 31, 44, 0) 88%);
    }

    .banner__cta-container {
        margin: 20px 0 10px;
        justify-content: center;
    }

    .banner.right .banner__container > .container .banner__cta-container a {
        margin-right: 0;
    }
    .banner__cta-container .btn-secondary {
        border-color: #fff;
    }

    .btn-secondary {
        color: #0b1f2c;
        background-color: #fff;
        border-color: #0b1f2c;
        font-family: "CabinetGrotesk-Regular", sans-serif;
    }
    .btn {
        transition: all .3s cubic-bezier(0.52, 0.12, 0.05, 0.95);
        border-radius: 25px;
        box-shadow: none;
        padding: 8px 15px;
        font-size: 12px;
        text-transform: uppercase;
        font-weight: 500;
        line-height: 25px;
        text-shadow: none;
        text-decoration: none;
        min-height: 45px;
    }

    .btn-secondary:hover {
        color: #fff;
        background-color: #4e5f6c;
        border-color: #4e5f6c;
    }

     /** RESPONSIV MEDIA  */
     @media (max-width: 600px) {

        .arm-not-found .banner__container > .container[data-v-2f8da421] {
            display: flex;
            justify-content: flex-start;
        }

        .arm-not-found .arm-text-inner{
            margin-left:20px;
        }


        .arm-text-inner .surtitle {
            font-size: 1.5em;
        }

        .arm-text-inner .banner__desc {
            font-size: 18px;
    
        }

        .arm-text-inner h1 {
            font-size: 5em;
          
        }

       

    }

            
</style>